import moment from 'moment'
import { TabError } from '@/utils/class/TabError'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { isArray } from '@/utils/validate'
import StrUtils from '@/utils/StrUtils'
import { PrintUtils } from '@/utils/PrintUtils'
import { sortByMultiFieldAndOrder } from '@/utils'
import * as CargoDocCfmState from '@/class/cargo/model/parameters/CargoDocCfmState'
import * as ReleaseState from '@/class/cargo/model/parameters/ReleaseState'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import * as BillReleaseType from '@/class/cargo/model/parameters/BillReleaseType'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import { DocCommon } from '@/class/cargo/model/utils/DocCommon'
import { SeaExportUtils } from '@/class/cargo/model/utils/SeaExportUtils'
import { Company } from '@/class/model/mdm/Company'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { AfrAddress } from '@/class/model/booking/AfrAddress'
import { EDIContainer } from '@/class/model/booking/EDIContainer'
import { Vessel } from '@/class/model/mdm/Vessel'
import { Voyage } from '@/class/model/mdm/Voyage'
import { unJointSlavesHblOrMbl } from '@/api/seaExport/seaExportJob'
import {
  xhqGetCfmAddress,
  xhqQueryCheckTheBLLog,
  surrendered,
  xhqUpdateBillInfo,
  xhqQueryAgentFeedbackCount, requestRelease, cancelRequestRelease, getGuaranteeStateInfo
} from '@/api/seaExport/seaCargoDoc'
import { Message } from '@/utils/Message'
import lang from '@/lang'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { CheckCargoDocHistory } from '@/class/model/booking/CheckCargoDocHistory'
import ColumnUtils from '@/utils/ColumnUtils'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { cache } from '@/utils/cacheManager'
import { getLoading } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import {
  CFM_BILL_STATE_NEW, CFM_BILL_STATE_RELEASE, CFM_BILL_STATE_UPDATE
} from '@/class/cargo/model/parameters/XhqBillCfmState'
import * as NumberUtils from '@/utils/NumberUtils'
import { sopTriggerHandler } from '@/api/booking/sopTrigger'
import { getDocumentTypeByExt } from '@/api/sysManage/baseConfig/docCategory'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { mergeArray, multiply } from '@/utils/commonUtil'
import * as ChargeMeasure from '@/class/cargo/model/parameters/ChargeMeasure'

export class TabHBL2PM {
  /**
  * @param {Object} view 视图
  */
  constructor(view) {
    this.view = view
    this.$message = view.$message
    this.$confirm = view.$confirm
    this.$i18n = view.$i18n
    this._hblCargoDoc = null
    this.prompt1TitleWindow = null
    this.promptTitleWindow = null
    this._editWindow = null
    this.afrAddressWindow = null
    this.usageSelectWindow = null
    this.originalPrintCheckSerialNo = false // 提单流水号打印验证
    this.joinMBLs = []
    this._allowEditingVessel = false
    this.editVesselVoyageMode = 2 // 船名编辑模式
    this.editVoyageMode = 2 // 航次
    this._voyages = null
    this._lclslaveEnabled = false
    this.dfSignDateHBLDisabledRanges = null
    this.mergerOfEnglishNames = 0
    this.currentVessel = null
    this.printParam4Type = [
      { label: '', data: '' },
      { label: 'AS CARRIER', data: 'AS CARRIER' },
      { label: 'AS AGENT FOR THE CARRIER', data: 'AS AGENT FOR THE CARRIER' },
      { label: 'AS AGENT FOR ', data: 'AS AGENT FOR ' }
    ]
    this.printParam5Type = [
      { label: '', data: '' },
      { label: 'SEABRIDGE FCL', data: 'DELIVERY ORDER FEE ON ACCOUNT OF CNEE' },
      { label: 'SEABRIDGE LCL NORMAL', data: 'DESTINATION CFS CHARGES INCL.DELIVERY ORDER FEE AND GSC CHARGES ON ACCOUNT OF CNEE' },
      { label: 'SEABRIDGE LCL INCLUDE CISF', data: 'DESTINATION CFS CHARGES INCL.DELIVERY ORDER FEE AND GSC CHARGES AND CISF ON ACCOUNT OF CNEE' }
    ]
    this.removeJointJob = null // 删除并单
    this.view.$nextTick(() => {
      this.creationCompleteHandler()
    })
    // _view.dgFreightCharges.addEventListener(KeyboardEvent.KEY_DOWN, freightChargesHandler)
  }
  get context() {
    return this.view.context
  }
  set context(context) {
    this.view.context = context
  }
  get companyList() {
    return this.view.context.companyList
  }
  set companyList(companyList) {
    this.view.context.companyList = companyList
  }
  get paymentTermList() {
    return this.view.context.paymentTermList
  }
  set paymentTermList(paymentTermList) {
    // 不可赋值
  }
  get packingList() {
    return this.view.context.packingList
  }
  set packingList(packingList) {
    // 不可赋值
  }
  get shippingTermList() {
    return this.view.context.shippingTermList
  }
  set shippingTermList(shippingTermList) {
    // 不可赋值
  }
  get user() {
    return this.context.user
  }
  set user(user) {
    // 不可赋值
  }
  get config() {
    return this.view.config
  }
  set config(config) {
    // 不可赋值
  }
  get job() {
    return this.view.job
  }
  set job(job) {
    this.view.job = job
  }
  get form() {
    return this.view.form
  }
  set form(form) {
    this.view.form = form
  }
  /**
   * init
   */
  init() {
    this.originalPrintCheckSerialNo = Number(this.config.get('originalPrintCheckSerialNo')) === 1
    this.editVesselVoyageMode = Number(this.config.get('EditVesselVoyageMode'))
    this.editVoyageMode = Number(this.config.get('EditVoyageMode'))
    // this.view.maxChars = Number(this.config.get('SEShipperConsigneNotifyMaxchars'))
    this.mergerOfEnglishNames = Number(this.config.get('MergerOfEnglishNames'))
    this.view.PICtoXHQDocumentCenter = Number(this.config.get('PICtoXHQDocumentCenter'))
    this.view.OpenXHQDocumentCenter = !(this.config.get('OpenXHQDocumentCenter') === '0')
    this.view.ToExoSystemJYD = this.config.get('ToExoSystem') === 'JYD'
    this.view.IfXHQReleaseRequireHBLReleaseReview = Number(this.config.get('IfXHQReleaseRequireHBLReleaseReview'))
    this.view.mblMergeUpdateMainNumber = Number(this.config.get('mblMergeUpdateMainNumber')) === 2
    this.editInputVesselModel()
    getSpecificBasicData(basicCacheKeys.basic_data_BlMode).then(data => {
      for (const item of data) {
        if (item.blType === 3) {
          const blMode = this.view.blModeList.find(p => p.uuid === item.uuid)
          if (!blMode) {
            this.view.blModeList.push(item)
          }
        }
      }
    })
  }
  /**
   * creationComplete
   */
  creationCompleteHandler() {
    this.lclslaveEnabledCl()
  }
  async display() {
    const job = new SeaExportJob(this.job)
    const cargoDoc = await job.getSeaCargoDoc()
    await this.loadCargoDoc2Handler(cargoDoc)
    if (job.typeHBL === BillType.MERGE_BILL_TYPE.code) { // 并单的时候, 需要加载并单数据
      const jointSlavesHBL = await job.getJointSlavesHBL()
      this.loadJointSlaves2Handler(jointSlavesHBL)
      if (this.view.OpenXHQDocumentCenter && this.form.uuid) {
        // 查询海外代理反馈记录条数,大于0说明有回传
        xhqQueryAgentFeedbackCount({ cargoDocUuid: this.form.uuid }).then(res => {
          if (res.data > 0) {
            this.view.showXhqOverseasAgentFeedbackLink = true
          } else {
            this.view.showXhqOverseasAgentFeedbackLink = false
          }
        })
      }
    }
  }
  fillView() {
    this.editInputVesselModel()
    this.lclslaveEnabledCl()
    this.ETD_changeCl()
    this.resetColor()
    if (this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_YQR.code || this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_SHIPPER_CONFIRMED.code) {
      this.loadCheckDocs()
    }
    if (this.view.isEdit) {
      this.refreshQuantitySum()
      this.setDefaultFreightTermHBL()
    }
  }
  setDefaultFreightTermHBL() {
    if (!this.form.freightTermHBL) {
      const shippingTerm = this.shippingTermList.find(p => p.code === this.job.freightTermHBL)
      if (shippingTerm) {
        this.form.freightTermHBL = shippingTerm.name
      }
    }
  }
  fillModel() {
    // 关联主单
    if (this.joinMBLs.length === 0) {
      this.form.mblId = this.getMBLCargoDoc()
    }
    this.view.$store.dispatch('log/addLog', {
      type: 'info',
      msg: 'hbl2:' + this.form,
      url: window.location.href
    })
    // 提单发货地
    this.form.dispatchingPlace = this.form.dispatchingPlace.toUpperCase()
    // 提单起运港
    this.form.loadingPort = this.form.loadingPort.toUpperCase()
    // 提单卸货港
    this.form.dischargingPort = this.form.dischargingPort.toUpperCase()
    // 提单目的港
    this.form.destinationPort = this.form.destinationPort.toUpperCase()
    // 提单目的地
    this.form.destinationPlace = this.form.destinationPlace.toUpperCase()
    // 提单份数
    this.form.blNumber = this.form.blNumber.toUpperCase()
    // 英文品名
    // this.form.cargoEnglishName = this.form.cargoEnglishName.toUpperCase()
    // 唛头
    // this.form.mark = this.form.mark.toUpperCase()
    // 提单备注
    this.form.remarks = this.form.remarks.toUpperCase()
    this.form.seaeq = this.form.seaeq.toUpperCase()
    this.form.container = this.form.container.toUpperCase()
    this.form.alsoNotify = this.form.alsoNotify.toUpperCase()
    this.changeAfrAddress()
    // 处理特殊字符
    JobUtils.handlingSpecialCharactersForCargoDoc(this.form)
  }
  print() {
    // if (null == view.cargoDoc) {
    //   this.$message.warning(this.view.$t('Message.NoSelectedCargoDocInformation'))
    //   return
    // }
    // var params1 = new Object()
    // if (view.job.typeHBL == BillType.SPLIT_BILL_TYPE.code) {
    //   if (view.gdHBL2.selectedItem) {
    //     params1.jobuuid = view.job.key
    //     params1.cargoDocUuid = view.cargoDoc.key
    //     params1.fileAliasName = view.cargoDoc.hblNbr2
    //     params1.DOC_UUID = view.cargoDoc.key
    //     TemplateSelectorWin.getInstance().showThisWin(view.job, 'HBL2', params1, view)
    //   }
    //   else {
    //     this.$message.warning(this.view.$t('Message.NoSelectedCargoDocInformation'))
    //   }
    // }
    // else if (view.job.typeHBL == BillType.MERGE_BILL_TYPE.code) {
    //   if (view.cargoDoc) {
    //     params1.jobuuid = view.job.key
    //     params1.cargoDocUuid = view.cargoDoc.key
    //     params1.fileAliasName = view.cargoDoc.hblNbr2
    //     params1.DOC_UUID = view.cargoDoc.key
    //     TemplateSelectorWin.getInstance().showThisWin(view.job, 'HBL2', params1, view)
    //   }
    // }
  }
  validateForm() {
    let _t_quantity = 0
    let _t_weight = 0
    let _t_cubage = 0
    if (this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code) {
      for (const item_hCargoDoc of this.view.splitOrder.rowData) {
        if (item_hCargoDoc.deleted) continue
        if (item_hCargoDoc.docType === CargoDocConsts.HBL2) {
          // 件数
          _t_quantity += Number(item_hCargoDoc.quantity)
          // 重量
          _t_weight += Number(item_hCargoDoc.weight)
          // 体积
          _t_cubage += Number(item_hCargoDoc.cubage)
        }
      }
      if ((_t_quantity !== 0 && _t_quantity !== Number(this.job.quantityActual)) ||
        (_t_weight !== 0 && _t_weight.toFixed(2) !== Number(this.job.weightActual).toFixed(2)) ||
        (_t_cubage !== 0 && _t_cubage.toFixed(3) !== Number(this.job.cubageActual).toFixed(3))) {
        // throw new TabError(this.view.$t('Message.TotalWeightOfLadingAreInconsistent'), 'tabHBL2')
        Message.warning(lang.t('Message.TotalWeightOfLadingAreInconsistent'))
      }
    } else if (this.job.typeHBL === BillType.MERGE_BILL_TYPE.code) {
      for (const item_hCargoDoc2 of this.job.seaCargoDoc) {
        if (item_hCargoDoc2.docType === CargoDocConsts.HBL) {
          // 件数
          _t_quantity += Number(item_hCargoDoc2.quantity)
          // 重量
          _t_weight += Number(item_hCargoDoc2.weight)
          // 体积
          _t_cubage += Number(item_hCargoDoc2.cubage)
          break
        }
      }
      // 并单件毛体
      for (const job of this.job.jointSlavesHBL) {
        // 件数
        _t_quantity += Number(job.quantityActual)
        // 重量
        _t_weight += Number(job.weightActual)
        // 体积
        _t_cubage += Number(job.cubageActual)
      }
      if (this.form.quantity && this.form.weight && this.form.cubage && ((_t_quantity !== 0 && _t_quantity !== Number(this.form.quantity)) ||
        (_t_weight !== 0 && _t_weight.toFixed(2) !== Number(this.form.weight).toFixed(2)) ||
        (_t_cubage !== 0 && _t_cubage.toFixed(3) !== Number(this.form.cubage).toFixed(3)))) {
        // throw new TabError(this.view.$t('Message.TotalWeightOfLadingAreInconsistent'), 'tabHBL2')
        Message.warning(lang.t('Message.TotalWeightOfLadingAreInconsistent'))
      }
    }
    if (this.form.releaseType && this.form.releaseType === BillReleaseType.SURRENDERED.code) {
      const regexp = /^\W*to\W*-?\W*order\W*$/i
      const _txtconsigneeLine1 = this.form.consigneeLine1.toLocaleLowerCase()
      if (regexp.test(_txtconsigneeLine1)) {
        throw new TabError(this.view.$t('Message.TOORDERIsUnavailableToRelease'), 'tabHBL2')
      }
    }
    return true
  }
  async executeTask() {
    DocCommon.HBL_History.shipperLine1 = this.form.shipperLine1
    DocCommon.HBL_History.shipperLine2 = this.form.shipperLine2
    DocCommon.HBL_History.shipperLine3 = this.form.shipperLine3
    DocCommon.HBL_History.shipperLine4 = this.form.shipperLine4
    DocCommon.HBL_History.shipperLine5 = this.form.shipperLine5
    DocCommon.HBL_History.shipperLine6 = this.form.shipperLine6
    DocCommon.HBL_History.shipperCode = this.shipperCode
    DocCommon.HBL_History.consigneeLine1 = this.form.consigneeLine1
    DocCommon.HBL_History.consigneeLine2 = this.form.consigneeLine2
    DocCommon.HBL_History.consigneeLine3 = this.form.consigneeLine3
    DocCommon.HBL_History.consigneeLine4 = this.form.consigneeLine4
    DocCommon.HBL_History.consigneeLine5 = this.form.consigneeLine5
    DocCommon.HBL_History.consigneeLine6 = this.form.consigneeLine6
    DocCommon.HBL_History.consigneeCode = this.form.consigneeCode
    DocCommon.HBL_History.notifyLine1 = this.form.notifyLine1
    DocCommon.HBL_History.notifyLine2 = this.form.notifyLine2
    DocCommon.HBL_History.notifyLine3 = this.form.notifyLine3
    DocCommon.HBL_History.notifyLine4 = this.form.notifyLine4
    DocCommon.HBL_History.notifyLine5 = this.form.notifyLine5
    DocCommon.HBL_History.notifyLine6 = this.form.notifyLine6
    DocCommon.HBL_History.notifyCode = this.form.notifyCode
    DocCommon.HBL_History.englishCargoName = this.form.cargoEnglishName
    DocCommon.HBL_History.mark = this.form.mark
    this.view.addrPM.isHBL = true
    this.view.addrPM.job = this.job
    this.view.addrPM.shipperCodeField = 'shipperCode'
    this.view.addrPM.shipperField = 'shipperLine'
    this.view.addrPM.consigneeCodeField = 'consigneeCode'
    this.view.addrPM.consigneeField = 'consigneeLine'
    this.view.addrPM.notifyCodeField = 'notifyCode'
    this.view.addrPM.notifyField = 'notifyLine'
    if (parseInt(this.config.get('syncMailingAddress')) === 1) {
      this.view.addrPM.saveCheck()
    }
    // addJoinMergeJobList.removeAll()
  }
  /**
   * 抄录收货人
   */
  onCopy_consignee(evt) {
    this.form.notifyCode = this.form.consigneeCode
    this.form.notifyLine1 = this.form.consigneeLine1
    this.form.notifyLine2 = this.form.consigneeLine2
    this.form.notifyLine3 = this.form.consigneeLine3
    this.form.notifyLine4 = this.form.consigneeLine4
    this.form.notifyLine5 = this.form.consigneeLine5
    this.form.notifyLine6 = this.form.consigneeLine6
    this.form.notifyLine7 = this.form.consigneeLine7
  }
  /**
   *  抄录1
   */
  onCopy1() {
    this.form.shipperCode = DocCommon.HBL_History.shipperCode
    this.form.shipperLine1 = DocCommon.HBL_History.shipperLine1
    this.form.shipperLine2 = DocCommon.HBL_History.shipperLine2
    this.form.shipperLine3 = DocCommon.HBL_History.shipperLine3
    this.form.shipperLine4 = DocCommon.HBL_History.shipperLine4
    this.form.shipperLine5 = DocCommon.HBL_History.shipperLine5
    this.form.shipperLine6 = DocCommon.HBL_History.shipperLine6
    this.form.consigneeCode = DocCommon.HBL_History.consigneeCode
    this.form.consigneeLine1 = DocCommon.HBL_History.consigneeLine1
    this.form.consigneeLine2 = DocCommon.HBL_History.consigneeLine2
    this.form.consigneeLine3 = DocCommon.HBL_History.consigneeLine3
    this.form.consigneeLine4 = DocCommon.HBL_History.consigneeLine4
    this.form.consigneeLine5 = DocCommon.HBL_History.consigneeLine5
    this.form.consigneeLine6 = DocCommon.HBL_History.consigneeLine6
    this.form.notifyCode = DocCommon.HBL_History.notifyCode
    this.form.notifyLine1 = DocCommon.HBL_History.notifyLine1
    this.form.notifyLine2 = DocCommon.HBL_History.notifyLine2
    this.form.notifyLine3 = DocCommon.HBL_History.notifyLine3
    this.form.notifyLine4 = DocCommon.HBL_History.notifyLine4
    this.form.notifyLine5 = DocCommon.HBL_History.notifyLine5
    this.form.notifyLine6 = DocCommon.HBL_History.notifyLine6
    this.form.cargoEnglishName = DocCommon.HBL_History.englishCargoName
    this.form.mark = DocCommon.HBL_History.mark
  }
  async onSplitSelectionChange(data) {
    if (!data) {
      return
    }
    this.fillModel()
    this.form = data
    this.view.curHbl = this.form
    this.form.chargePrint = true // 费用打印会用到选中行数据，这里加个标识
    this.setDefaultFreightTermHBL()
    this.editingChanged()
    if (this.form.uuid) {
      await new SeaCargoDoc(this.form).loadCargoDocRelated(true, true, true)
      this.loadAfrAddressHandler(this.form.afrAddress[0])

      await this.updateGuaranteeStateInfo()
    } else {
      this.form.afrAddress = this.form.afrAddress || []
      this.form.ediContainer = this.form.ediContainer || []
      this.form.freightCharges = this.form.freightCharges || []
      this.loadAfrAddressHandler(null)
    }
    this.view.container.rowData = this.form.ediContainer
    this.loadFreightChargesHandler(this.form.freightCharges)
    this.showDocState()
    this.resetColor()
    if (this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_YQR.code ||
        this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_SHIPPER_CONFIRMED.code) {
      await this.loadCheckDocs()
    }
    if (this.view.OpenXHQDocumentCenter && this.form.uuid) {
      // 查询海外代理反馈记录条数,大于0说明有回传
      xhqQueryAgentFeedbackCount({ cargoDocUuid: this.form.uuid }).then(res => {
        if (res.data > 0) {
          this.view.showXhqOverseasAgentFeedbackLink = true
        } else {
          this.view.showXhqOverseasAgentFeedbackLink = false
        }
      })
    }
  }
  /**
   * 新增并单或者拆单
   */
  async onAddCargoDoc2(isAdd = false) {
    if (!isAdd && this.form) {
      const joinMBLs = this.joinMBLs.filter(p => p.uuid)
      if (!this.form.mblId && joinMBLs.length > 0 && this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code) {
        this.$message.warning(this.view.$t('Message.TheAssociatedPrimaryFormIsNotSelected'))
        return
      }
      if (this.form.releaseType && this.form.releaseType === BillReleaseType.SURRENDERED.code) {
        const regexp = /^\W*to\W*-?\W*order\W*$/i
        if (regexp.test(this.form.consigneeLine1)) {
          this.$message.warning(this.view.$t('Message.TOORDERIsUnavailableToRelease'))
          return
        }
      }
    } else {
      this.form = new SeaCargoDoc().fillDefaultValue().getData()
    }
    this.fillModel()
    this.view.curHbl = this.form
    // 初始化拆并单数据
    await CargoDocUtil.onAddHbl2CargoDoc(this.form, this.job, this._hblCargoDoc)
    // 生成分单号
    const prefix = (this._hblCargoDoc.hblNbr2 ? this._hblCargoDoc.hblNbr2 : this.job.jobNo) + '-'
    const hblRefNoPrefix = this.job.jobNo + '-' // 生成HBL Ref No.
    let curCode = 0
    let hblRefNoCurCode = 0
    if (this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code) { // 拆单
      // 重新计算拆单件毛体
      for (const item of this.view.splitOrderFinalRowData) {
        // 件数
        this.form.quantity = this.form.quantity - item.quantity
        // 重量
        this.form.weight = this.form.weight - item.weight
        // 体积
        this.form.cubage = this.form.cubage - item.cubage
        // 分单号
        const hblNbr2 = item.hblNbr2
        if (hblNbr2.startsWith(prefix)) {
          const code = Number(hblNbr2.substr(prefix.length))
          if (code && code > curCode) {
            curCode = code
          }
        }
        // hblRefNo
        const hblRefNo = item.hblRefNo
        if (hblRefNo.startsWith(hblRefNoPrefix)) {
          const code = Number(hblRefNo.substr(hblRefNoPrefix.length))
          if (code && code > hblRefNoCurCode) {
            hblRefNoCurCode = code
          }
        }
      }
    }
    this.form.hblNbr2 = prefix + (curCode + 1)
    if (this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code) {
      this.form.hblRefNo = hblRefNoPrefix + (hblRefNoCurCode + 1) // HBL Ref No.生成后缀规则和拆单hblNbr2保持一致
    }
    this.form.warehouseNo = this.form.hblNbr2
    if (this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code) { // 拆单
      this.view.splitOrder.rowData.push(this.form)
      this.view.curHbl = this.form
      this.job.seaCargoDoc.push(this.form)
      if (this.joinMBLs.length === 0) {
        this.form.mblId = this.getMBLCargoDoc()
      }
      setTimeout(() => {
        this.setSelectNode(this.view.splitOrderFinalRowData.length - 1)
      }, 100)
      this.editingChanged()
      this.loadAfrAddressHandler(null)
      await new SeaCargoDoc(this.form).loadCargoDocRelated(false, true, true)
      this.view.container.rowData = this.form.ediContainer
      this.loadFreightChargesHandler(this.form.freightCharges)
      this.refreshQuantitySum()
      this.form.insideQuantity = this.job.insideQuantity
      this.form.insidePacking = this.job.insidePacking
      await this.changeContainer()
      // 新增拆单，重新计算计费重量
      this.calculateChargeWeight()
    } else {
      this.view.chkConsolidationClosed = false
      this.form.afrAddress = this.form.afrAddress || []
      this.form.ediContainer = this.form.ediContainer || []
      this.form.freightCharges = this.form.freightCharges || []
      this.view.container.rowData = this.form.ediContainer
      this.loadFreightChargesHandler(this.form.freightCharges)
      this.refreshQuantitySum()
      this.form.insideQuantity = this.job.insideQuantity
      this.form.insidePacking = this.job.insidePacking
      this.changeContainer()
    }
  }
  getMBLCargoDoc() {
    if (this.job.seaCargoDoc) {
      for (const item of this.job.seaCargoDoc) {
        if (item.docType === CargoDocConsts.MBL) {
          return item.uuid
        }
      }
    }
    return ''
  }
  onRemoveCargoDoc() {
    const selectedRows = this.view.splitOrder.gridApi.getSelectedRows()
    const row = selectedRows.length ? selectedRows[0] : null
    if (row) {
      for (const item of this.job.seaCargoDoc) {
        if (row.hblNbr2 === item.hblRefNo && !item.deleted && item.docType === CargoDocConsts.HAWB2) {
          this.$message.warning(this.view.$t('SeaExport.PleaseRemovedSplitOrder'))
          return
        }
      }
      this.$confirm(
        this.view.$t('Message.AreYouSureYouWantToDelete1') + row.hblNbr2 + this.view.$t('Message.AreYouSureYouWantToDelete2'),
        this.view.$t('Message.ConfirmDelete'), {
          confirmButtonText: this.view.$t('common.btn.ok'),
          cancelButtonText: this.view.$t('common.btn.cancel'),
          type: 'warning'
        }
      ).then(async() => {
        await this.onRemoveConfirmed(row)
        this.setSelectNode(0)
      }).catch(() => { })
    } else {
      this.$message.warning(this.view.$t('Message.PleaseSelectHBLNo'))
    }
  }
  async onRemoveConfirmed(row) {
    if (row.uuid) {
      row.deleted = true
      const tempRowData = this.view.splitOrder.rowData
      // this.view.splitOrder.rowData = []
      // this.view.$nextTick(() => {
      //   this.view.splitOrder.rowData = tempRowData
      // })
      const index = tempRowData.indexOf(row)
      if (index > -1) {
        // 找到原来的元素删除，并将row添加到删除元素的位置
        tempRowData.splice(index, 1, row)
      }
      const cargoDoc = this.job.seaCargoDoc.find(p => p.uuid === row.uuid)
      if (cargoDoc) cargoDoc.deleted = true
    } else {
      const index = this.view.splitOrder.rowData.findIndex(p => p === row)
      if (index > -1) {
        this.view.splitOrder.rowData.splice(index, 1)
      }
      const cargoDocIndex = this.job.seaCargoDoc.findIndex(p => p === row)
      if (cargoDocIndex >= 0) {
        this.job.seaCargoDoc.splice(cargoDocIndex, 1)
      }
    }
    if (this.view.splitOrderFinalRowData.length > 0) {
      this.form = this.view.splitOrderFinalRowData[0]
      this.view.curHbl = this.form
      this.printStateChange()
    } else {
      // 不存到数据库
      this.form = new SeaCargoDoc().fillDefaultValue().getData()
      this.form.releaseType = 1
      this.editingChanged()
    }
    this.setDefaultFreightTermHBL()
    await new SeaCargoDoc(this.form).loadCargoDocRelated(false, true, true)
    this.view.container.rowData = this.form.ediContainer
    this.loadFreightChargesHandler(this.form.freightCharges)
    this.refreshQuantitySum()
    this.resetColor()
    if (this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_YQR.code ||
        this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_SHIPPER_CONFIRMED.code) {
      await this.loadCheckDocs()
    }
  }
  /**
   * 添加并单
   */
  onMergeAddJob() {
    const excludeUuids = Array.from(this.view.mergeOrderFinalRowData, p => p.uuid)
    // this.job.key = this.job.uuid
    Object.assign(this.view.searchJobNoDialog.params, {
      selectType: 'multiple',
      docType: this.form.docType,
      job: this.job,
      useDefaultCondition: true,
      excludeUuids
    })
    this.view.searchJobNoDialog.selectHandler = p => { this.selectionItemsHandler(p) }
    this.view.searchJobNoDialog.visible = true
  }
  /**
   * 删除并单
   */
  onMergeRemoveJob() {
    const doc = this.view.mergeOrder.gridApi.getSelectedRows()[0]
    if (doc) {
      this.$confirm(
        this.view.$t('Message.AreYouSureYouWantToDelete1') + doc.jobNo + this.view.$t('Message.AreYouSureYouWantToDelete2'),
        this.view.$t('Message.ConfirmDelete'), {
          confirmButtonText: this.view.$t('common.btn.ok'),
          cancelButtonText: this.view.$t('common.btn.cancel'),
          type: 'warning'
        }
      ).then(() => {
        this.onJobsRemoveConfirmed(doc)
      }).catch(() => { })
    } else {
      this.$message.warning(this.view.$t('SeaExport.SelectAPieceOfData'))
      return
    }
  }
  onJobsRemoveConfirmed(job) {
    // 先保留原始的值，如果调用后端请求失败，则还原这几个字段
    const oldCargoDoc = {
      quantity: this.form.quantity,
      weight: this.form.weight,
      cubage: this.form.cubage,
      chargeWeight: this.form.chargeWeight
    }
    // 件数
    let quantity = this.form.quantity - job.quantityActual
    // 重量和体积 不加这个校验，是因为三者页面组件不同
    if (quantity < 0) {
      quantity = 0
    }
    // 重量
    const weight = this.form.weight - job.weightActual
    // 体积
    const cubage = this.form.cubage - job.cubageActual
    // 计费重量
    const chargeWeight = this.form.chargeWeight - job.chargeWeight
    // 如果提单是已经真是存在的,此时立即调用移除并单操作，并且已经真实并入的才能调用后台
    if (this.form.uuid && job && job.jointMasterHBLUuid) {
      const param = {}
      param.docType = 'HBL2'
      param.job = { key: this.job.uuid, version: this.job.version }
      param.unJob = { key: job.uuid, version: job.version }
      param.cargoDoc = {
        key: this.form.uuid,
        version: this.form.version,
        quantity: isNaN(quantity) ? 0 : Number(quantity),
        weight: isNaN(weight) ? 0 : Number(weight),
        cubage: isNaN(cubage) ? 0 : Number(cubage),
        chargeWeight: isNaN(chargeWeight) ? 0 : Number(chargeWeight)
      }
      unJointSlavesHblOrMbl(param).then(res => {
        if (res.data) { // 由于是编辑状态下,所以删除操作成功以后要更新对应的字段以及版本号
          const index = this.view.mergeOrder.rowData.findIndex(p => p.uuid === job.uuid)
          if (index >= 0) {
            this.view.mergeOrder.rowData.splice(index, 1)
          }
          if (res.data.job) {
            this.job.version = res.data.job.version
            this.job.joinFlagHBL = res.data.job.joinFlagHBL
            this.job.jointMasterHBLUuid = res.data.job.jointMasterHBLUuid
            this.view.$emit('syncData', {
              jointMasterHBLUuid: this.job.jointMasterHBLUuid,
              joinFlagHBL: this.job.joinFlagHBL,
              version: this.job.version
            })
          }
          if (res.data.cargoDoc) {
            this.form.version = res.data.cargoDoc.version
            this.form.quantity = res.data.cargoDoc.quantity
            this.form.weight = res.data.cargoDoc.weight
            this.form.cubage = res.data.cargoDoc.cubage
            this.form.chargeWeight = res.data.cargoDoc.chargeWeight
            this.view.$emit('syncData', { cargoDoc: '', seaCargoDoc: '', isCompleteRow: false })
          }
          this.view.$emit('syncData', { jointSlavesHBL: '', isCompleteRow: false })
          if (this.view.mergeOrder.rowData.length <= 0) {
            // CARGO-36378 HBL普票业务，存在并单数据
            if (this.job.seaCargoDoc && this.job.seaCargoDoc.length > 0) {
              for (const item of this.job.seaCargoDoc) {
                if (item.uuid === res.data.cargoDoc.uuid) {
                  item.deleted = true
                }
              }
            }
          }
        }
      }).catch(() => {
        this.form.quantity = oldCargoDoc.quantity
        this.form.weight = oldCargoDoc.weight
        this.form.cubage = oldCargoDoc.cubage
        this.form.chargeWeight = oldCargoDoc.chargeWeight
      })
    } else {
      // 移除addJoinMergeJobList中的数据
      const addJoinMergeJobList = this.view.addJoinMergeJobList
      if (addJoinMergeJobList && addJoinMergeJobList.length > 0) {
        for (let i = 0; i < addJoinMergeJobList.length; i++) {
          if (addJoinMergeJobList[i].key === job.uuid) {
            addJoinMergeJobList.splice(i, 1)
            break
          }
        }
      }
      const index = this.view.mergeOrder.rowData.findIndex(p => p.uuid === job.uuid)
      if (index >= 0) {
        this.view.mergeOrder.rowData.splice(index, 1)
      }
      this.form.quantity = quantity
      this.form.weight = weight
      this.form.cubage = cubage
      this.form.chargeWeight = chargeWeight
    }
    this.resetColor()
    if (this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_YQR.code || this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_SHIPPER_CONFIRMED.code) {
      this.loadCheckDocs()
    }
    // 移除并单时需要判断费用中数量需要重新计算
    this.refreshCharge()
  }
  /**
   * 获取真实的件毛体信息
   */
  getUnJointDocUpdateParam() {
    // var param = {}
    // param.job = view.job
    // param.unJob = removeJointJob
    // param.cargoDoc = view.cargoDoc
    // return param
  }
  saveAllSuccessHandler(result) {
    // if (addJoinMergeJobList != null && addJoinMergeJobList.length > 0) {
    //   addJoinMergeJobList.removeItemAt(addJoinMergeJobList.getItemIndex(removeJointJob))
    // }
    // removeJointJob.reloadJointSlavesHBL(new Responder(loadJointSlaves2Handler, view.faultHandler))
  }
  selectionItemHandler(rows) {
    const selectedHBL = isArray(rows) ? rows[0] : rows
    if (selectedHBL && Object.keys(selectedHBL).length > 0) {
      this.form.shipperCode = selectedHBL.shipperCode
      this.form.shipperLine1 = selectedHBL.shipperLine1
      this.form.shipperLine2 = selectedHBL.shipperLine2
      this.form.shipperLine3 = selectedHBL.shipperLine3
      this.form.shipperLine4 = selectedHBL.shipperLine4
      this.form.shipperLine5 = selectedHBL.shipperLine5
      this.form.shipperLine6 = selectedHBL.shipperLine6

      this.form.consigneeCode = selectedHBL.consigneeCode
      this.form.consigneeLine1 = selectedHBL.consigneeLine1
      this.form.consigneeLine2 = selectedHBL.consigneeLine2
      this.form.consigneeLine3 = selectedHBL.consigneeLine3
      this.form.consigneeLine4 = selectedHBL.consigneeLine4
      this.form.consigneeLine5 = selectedHBL.consigneeLine5
      this.form.consigneeLine6 = selectedHBL.consigneeLine6

      this.form.notifyCode = selectedHBL.notifyCode
      this.form.notifyLine1 = selectedHBL.notifyLine1
      this.form.notifyLine2 = selectedHBL.notifyLine2
      this.form.notifyLine3 = selectedHBL.notifyLine3
      this.form.notifyLine4 = selectedHBL.notifyLine4
      this.form.notifyLine5 = selectedHBL.notifyLine5
      this.form.notifyLine6 = selectedHBL.notifyLine6

      this.form.cargoEnglishName = this.job.cargoEnglishName
      this.form.mark = this.job.mark
    }
  }
  async selectionItemsHandler(data) {
    if (!this.view.mblMergeUpdateMainNumber) {
      this.view.isItCleared = await JobUtils.vesselOrVoyageChange2(data, this.job, this.view)
    }
    const rowData = this.view.mergeOrder.rowData
    let usages = []
    const jobKeySet = {}
    for (const seaJob of rowData) {
      jobKeySet[seaJob.uuid] = true
      if (seaJob.containerUsages && seaJob.containerUsages.length > 0) {
        usages = usages.concat(seaJob.containerUsages)
      }
    }
    const selectedJobs = []
    for (const sJob of data) {
      if (!jobKeySet[sJob.uuid]) {
        selectedJobs.push(sJob)
        rowData.push(sJob)
        this.view.addJoinMergeJobList.push({ masterJobUuid: this.job.uuid, key: sJob.uuid, version: sJob.version, type: 'HBL', vessel: this.job.vessel, voyageFlight: this.job.voyageFlight, atd: this.job.atd, mbl: this.job.mbl, containerLoadType: sJob.containerLoadType })
      }
      if (sJob.containerUsages && sJob.containerUsages.length > 0) {
        usages = usages.concat(sJob.containerUsages)
      }
    }
    // this.view.mergeOrder.rowData = [...rowData]
    SeaExportUtils.jointJobsHBL(this.job, this.form, selectedJobs)
    this.refreshQuantitySum()
    let tempCargoEnglishName = this.form.cargoEnglishName
    const obj = SeaExportUtils.jointSeqContainerInfo(this.form.seaeq, this.form.container, this.job, this.form, selectedJobs, Number(this.form.chargeWeight))
    if (tempCargoEnglishName) {
      tempCargoEnglishName += '\n'
    }
    if (this.mergerOfEnglishNames === 1) {
      tempCargoEnglishName += obj.cargoEnglishName2
    } else {
      tempCargoEnglishName += obj.cargoEnglishName
    }
    this.form.cargoEnglishName = tempCargoEnglishName
    this.form.chargeWeight = obj.chargeWeight
    // 唛头
    let mark = this.form.mark
    if (obj.mark) {
      if (mark) {
        mark = mark + '\n' + obj.mark
      } else {
        mark = obj.mark
      }
    }
    this.form.mark = mark
    this.addUsageForGrid(usages)
    this.refreshSeqContainer()
    this.refreshCharge()
  }

  /**
   * 刷新费用新悦
   * @returns {Promise<void>}
   */
  async refreshCharge() {
    if (String(cache.config.get('ToExoSystem')) === 'XYCW') {
      const insideQuantityCharges = []
      const weightCharges = []
      const cubageCharges = []
      const chargeWeightCharges = []
      for (const charge of this.job.charges) {
        if (BillType.MERGE_BILL_TYPE.code === this.job.typeHBL) {
          if (await ChargeUtils.checkChargeData(charge, ChargeMeasure.INSIDEPIECE_CHARGE_MEASURE.code, this.job)) {
            insideQuantityCharges.push(charge)
          }
          if (await ChargeUtils.checkChargeData(charge, ChargeMeasure.WGT_CHARGE_MEASURE.code, this.job)) {
            weightCharges.push(charge)
          }
          if (await ChargeUtils.checkChargeData(charge, ChargeMeasure.VOL_CHARGE_MEASURE.code, this.job)) {
            cubageCharges.push(charge)
          }
          if (await ChargeUtils.checkChargeData(charge, ChargeMeasure.WGTX_CHARGE_MEASURE.code, this.job)) {
            chargeWeightCharges.push(charge)
          }
        }
      }
      if (insideQuantityCharges.length > 0 || weightCharges.length > 0 || cubageCharges.length > 0 || chargeWeightCharges.length > 0) {
        await this.view.$confirm(this.view.$t('Message.ChangeToRefreshCostBasedOnCubagePrice'), {
          confirmButtonText: this.view.$t('common.btn.ok'),
          cancelButtonText: this.view.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          const hbl2 = this.job.seaCargoDoc.find(p => p.docType === CargoDocConsts.HBL2)
          this.refreshChargeAndCalculate(insideQuantityCharges, hbl2.insideQuantity)
          this.refreshChargeAndCalculate(weightCharges, hbl2.weight)
          this.refreshChargeAndCalculate(cubageCharges, hbl2.cubage)
          this.refreshChargeAndCalculate(chargeWeightCharges, hbl2.chargeWeight)
        })
      }
    }
  }
  async refreshChargeAndCalculate(charges, quantity) {
    for (const charge of charges) {
      charge.quantity = quantity || 1
      if (charge.unitPriceIncludeTax) {
        ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
      } else {
        ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
      }
    }
    this.view.context.modifiedData.charges = this.view.context.modifiedData.charges || []
    mergeArray(this.view.context.modifiedData.charges, charges)
    this.view.context.reloadCharge = true
  }
  /**
   * 复制主单收货人
   */
  async onCopy_agentParty() {
    const mdoc = await new SeaExportJob(this.job).getMainMbl()
    if (mdoc) {
      this.form.agentPartyLine1 = mdoc.consigneeLine1
      this.form.agentPartyLine2 = mdoc.consigneeLine2
      this.form.agentPartyLine3 = mdoc.consigneeLine3
      this.form.agentPartyLine4 = mdoc.consigneeLine4
      this.form.agentPartyLine5 = mdoc.consigneeLine5
      this.form.agentPartyLine6 = mdoc.consigneeLine6
      this.form.agentPartyLine7 = mdoc.consigneeLine7
    }
  }
  /**
   * 取指定货代理信息
   */
  onCopy_designationAgent() {
    const cpy = this.context.companyList.find(p => p.cmpIdx === this.job.designationAgent)
    if (cpy) {
      new Company(cpy).getOverseaAgentDetail().then(data => {
        this.loadDestinationAgentHandler(data)
      })
    }
  }
  loadDestinationAgentHandler(overseaAgentDetail) {
    if (overseaAgentDetail) {
      this.form.agentPartyLine1 = overseaAgentDetail.blAddress
      this.form.agentPartyLine2 = overseaAgentDetail.blAddressLine2
      this.form.agentPartyLine3 = overseaAgentDetail.blAddressLine3
      this.form.agentPartyLine4 = overseaAgentDetail.blAddressLine4
      this.form.agentPartyLine5 = overseaAgentDetail.blAddressLine5
      this.form.agentPartyLine6 = overseaAgentDetail.blAddressLine6
      this.form.agentPartyLine7 = overseaAgentDetail.blAddressLine7
    }
  }
  /**
   * select
   */
  async usageSelectCallBackFunc(usages) {
    this.view.container.rowData = await new SeaCargoDoc(this.form).getEdiContainer()
    if (this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code) { // 拆单
      if (Number(cache.config.get('SplitDocContainerAutoCalculateQWC')) === 1) {
        this.addUsageForGrid(usages)
      } else {
        this.addUsageForGridByUuid(usages)
      }
    } else {
      this.addUsageForMerge(usages)
    }
    this.view.container.gridApi.refreshCells({ force: true })
    await this.refreshSeqContainer()
    // 拆单专用
    if (this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code && !this.view.isXy) {
      this.refreshEdiGrid()
    }
  }

  /**
   * refresh  刷新计件重体
   */
  refreshEdiGrid() {
    if (this.view.container.rowData && this.view.container.rowData.length > 0) {
      let quantity = 0
      let weight = 0.000
      let cubage = 0.000
      const pakInfo = this.view.container.rowData.filter(p => !p.deleted)
      if (pakInfo && pakInfo.length > 0) {
        for (const container of pakInfo) {
          quantity += Number(container.quantity) || 0
          weight += Number(container.weight) || 0
          cubage += Number(container.cubage) || 0
        }
      }
      this.form.quantity = quantity
      this.form.weight = weight
      this.form.cubage = cubage
      CargoDocUtil.calculateSEChargeWeight(this.form)
    } else {
      // 移除完箱子后清空件毛体
      this.form.quantity = 0
      this.form.weight = 0
      this.form.cubage = 0
      this.form.chargeWeight = 0
    }
  }
  /**
   * 拆单计费重量修改计算
   */
  calculateChargeWeight() {
    let weight = Number(this.form.weight)
    const cubage = Number(this.form.cubage)
    if (isNaN(weight) || isNaN(cubage)) {
      return
    }
    weight = weight / 1000
    if (cubage > weight) {
      weight = cubage
    }
    if (weight > 0 && weight < 1) {
      weight = 1.00
    }
    this.form.chargeWeight = weight.toFixed(3)
  }
  /**
   *  提单类型
   */
  cmbreleaseTypeMBLChangeHandler(val) {
    if (Number(val) === 1) {
      this.form.blNumber = 'THREE'
    } else {
      this.form.blNumber = 'ONE'
    }
  }
  /**
   * 锁定按钮处理
   */
  onUnlockStateEvent(evt) {
    // view.cargoDoc.state = 1
    // view.cargoDoc.save2(loadJointSlaves2Handler, view.faultHandler)
  }
  packing_Change(data) {
    this.form.packing = data.value
    this.refreshQuantitySum()
  }
  quantity_Change() {
    this.refreshQuantitySum()
  }
  print_callback(event) {
    const action = event && event.action ? String(event.action) : ''
    // Debug: trace why /seaCargoDoc/surrendered isn't triggered
    // eslint-disable-next-line no-console
    console.log(`[HBL2PM][print_callback] action=${action} category=${(this.view && this.view.templateSelectorDialog && this.view.templateSelectorDialog.category) || ''} cargoDocUuid=${(this.form && this.form.uuid) || ''}`)
    if (action === 'print') {
      // CARGO-39566 正本打印/电放打印，不影响 “提单确认状态”状态 （可做平台优化）
      // this.form.cfmState = CargoDocCfmState.CARGODOC_CFM_STATE_RELEASED.code // 已放单
      this.form.state = 2
      this.form.releaseState = ReleaseState.ONSINGLERELEASE.code
      // eslint-disable-next-line no-console
      console.log(`[HBL2PM][print_callback] call surrendered: uuid=${this.form.uuid} state=${this.form.state} releaseState=${this.form.releaseState} cfmState=${this.form.cfmState}`)
      surrendered({ cargoDocUuid: this.form.uuid, cfmState: this.form.cfmState, state: this.form.state, releaseState: this.form.releaseState }).then(async res => {
        if (res.data) {
          Object.assign(this.form, res.data)
          this.view.billLadingIssued = ColumnUtils.bliStatusLabelFunc(this.form.bliStatus)
          this.printStateChange()
          this.showDocState()
        }
      }).catch((e) => {
        // eslint-disable-next-line no-console
        console.log(`[HBL2PM][print_callback] surrendered error: ${e && e.message ? e.message : String(e)}`)
      })
    }
  }
  v2CheckCallbackFun2(printed, template, entity, params) {
    // eslint-disable-next-line no-console
    console.log(`[HBL2PM][v2CheckCallbackFun2] printed=${printed} eventAction=${(params && params.event && params.event.action) || ''} cargoDocUuid=${(this.form && this.form.uuid) || ''}`)
    if (printed && params.event && params.event.action === PrintUtils.PRINT) {
      // eslint-disable-next-line no-console
      console.log(`[HBL2PM][v2CheckCallbackFun2] call surrendered: uuid=${this.form.uuid} state=2 releaseState=${ReleaseState.ONSINGLERELEASE.code} cfmState=${this.form.cfmState}`)
      surrendered({ cargoDocUuid: this.form.uuid, cfmState: this.form.cfmState, state: 2, releaseState: ReleaseState.ONSINGLERELEASE.code }).then(res => {
        if (res.data) {
          Object.assign(this.form, res.data)
          this.view.billLadingIssued = ColumnUtils.bliStatusLabelFunc(this.form.bliStatus)
          this.view.lblReleaseState = ColumnUtils.releaseStateLabelFunc(this.form.releaseState)
          this.printStateChange()
        }
      }).catch((e) => {
        // eslint-disable-next-line no-console
        console.log(`[HBL2PM][v2CheckCallbackFun2] surrendered error: ${e && e.message ? e.message : String(e)}`)
      })
    }
  }
  /**
   * 开始创建File
   */
  startCreateFile() {
    // if (view.cargoDoc == null)
    //   return
    // File.queryFilesCount({ 'jobNo': view.cargoDoc.job.jobNo, 'fileNo': view.cargoDoc.hblNbr2 },
    //   new mx.rpc.Responder(fileCountResultHandler, fileCountFaultHandler))
  }
  fileCountResultHandler(result) {
    // if (result.result <= 0)
    //   createFileOnPrintZB()
    // else
    //   LOGGER.info('already exists a same file!')
  }
  fileCountFaultHandler(fault) {
    // LOGGER.error('query file count fault:' + fault.toString())
  }
  /**
   * 生成单证流转在打印正本的时候
   */
  createFileOnPrintZB() {
    // var file: File = File.createFileByJob(view.cargoDoc.job)
    // file.fileType = FileType.HBL_TYPE.code + ''
    // file.fileNo = view.cargoDoc.hblNbr2
    // file.save2(saveFileResultHandler, saveFileFaultHandler)
  }
  saveFileResultHandler(result) {
    // LOGGER.debug('generate HBL file success!')
  }
  saveFileFaultHandler(fault) {
    // LOGGER.error('generate HBL file fault!', fault.toString())
  }
  // 锁定按钮处理
  onSubmitStatEvent(event) {
    surrendered({ cargoDocUuid: this.form.uuid, cfmState: this.form.cfmState, state: 1, releaseState: ReleaseState.SINGLERELEASE.code }).then(res => {
      if (res.data) {
        Object.assign(this.form, res.data)
        this.printStateChange()
        this.showDocState()
        if (this.view.isEdit) {
          this.view.$emit('syncData', { cargoDoc: '', seaCargoDoc: '', isCompleteRow: false })
        }
      }
    })
  }
  /**
   * 船名选择
   */
  onVesselSelectionChange(data) {
    if (!data.uuid) {
      const vessel = this.vesselList.find(p => p.englishName === data.value)
      if (!vessel) {
        return
      }
      Object.assign(data, vessel)
    }
    this.currentVessel = data
    this.job.vessel = data.value
    this.getVoyageByVessel()
    new Vessel(this.currentVessel).getVesselCarriers().then(data => {
      this.getVesselCarrier(data)
    })
  }
  /**
   * 获取船舶呼号code
   */
  getVesselCarrier(vesselCarriers) {
    for (const carrier of vesselCarriers) {
      if (carrier.carrierId === this.job.carrierId) {
        this.job.vesselCode = carrier.ediCode
        break
      }
    }
  }
  async getVoyageByVessel() {
    if (this.currentVessel) {
      this._voyages = await Voyage.getVoyage(this.currentVessel.vesselId)
    } else {
      this._voyages = []
    }
  }
  txtVoyagefocusInHandler() {
    let value = 'V.'
    if (this.job.voyageFlight) {
      value = this.job.voyageFlight
      this.job.voyageFlight = ''
    }
    this.view.$nextTick(() => {
      this.job.voyageFlight = value
      const elSelect = this.view.$refs.voyageFlight
      const innerInput = elSelect.$children[0].$refs.input
      innerInput.value = this.job.voyageFlight
    })
  }
  async txtVoyagefocusOutHandler() {
    const job = this.job
    const elSelect = this.view.$refs.voyageFlight
    const innerInput = elSelect.$children[0].$refs.input
    job.voyageFlight = innerInput.value
    if (job.bookingTerm === BookingTerm.SB_BOOKING_TYPE.code && job.destinationPortCode && job.destinationPortCode.length && job.carrierId) {
      if (job.vessel && job.voyageFlight.length > 2) {
        const ediCode = await Vessel.getEDICode(job.vessel, job.voyageFlight, job.destinationPortCode, job.carrierId)
        if (ediCode) {
          job.vesselCode = ediCode
        }
      }
    }
  }
  paymentTermHBL_Change(value) {
    this.form.paymentTermHBL = value
    if (value === 'PP') {
      this.form.paymentPlaceHBL = this.form.loadingPort
    } else {
      this.form.paymentPlaceHBL = this.form.destinationPort
    }
  }
  paymentSelectHblChange(data) {
    this.form.paymentTerm = data.value
    this.paymentTermHBL_Change(data.value)
  }
  freightChargesHandler(freightCharges) {
    this.view.rowData = freightCharges
  }
  reloadCargoDocHandler(e = null) {
    this.fillView()
  }
  showDocState() {
    const isZh = this.$i18n.locale === 'zh'
    const releaseState = ReleaseState.getReleaseStateByCode(this.form.releaseState)
    if (releaseState) {
      this.view.lblReleaseState = isZh ? releaseState.chineseName : releaseState.englishName
    }
    const cfmState = CargoDocCfmState.getCargoDocCfmStateByCode(this.form.cfmState)
    if (cfmState) {
      this.view.lblCfrState = isZh ? cfmState.chineseName : cfmState.englishName
    }

    const bliStatus = CargoDocCfmState.getCargoDocBliStateByCode(this.form.bliStatus)
    if (bliStatus) {
      this.view.billLadingIssued = isZh ? bliStatus.chineseName : bliStatus.englishName
    }
  }
  async confirmBtn_clickHandler() {
    this.context.loading = true
    try {
      if (this.form.isDirty) {
        await this.updateForm()
      }
      this.form.cfmState = CargoDocCfmState.CARGODOC_CFM_STATE_YQR.code
      await new SeaCargoDoc(this.form).save()
      this.form.isDirty = true
      await this.updateForm()
    } finally {
      this.context.loading = false
    }
  }

  /**
   * 信号旗确认对单
   */
  async xhqConfirmBL() {
    this.context.loading = true
    try {
      if (this.form.isDirty) {
        await this.updateForm()
      }
      if (this.form.cfmState >= CargoDocCfmState.CARGODOC_CFM_STATE_EXCEPTION.code && this.form.customerSelfRelease === 1) {
        this.form.releaseState = ReleaseState.ONSINGLERELEASE.code
        this.form.bliStatus = 12
      }
      this.form.cfmState = CargoDocCfmState.CARGODOC_CFM_STATE_YQR.code
      await new SeaCargoDoc(this.form).save()
      this.form.isDirty = true
      await this.updateForm()
      // CARGO-39946 信号旗确认对单后，触发sop
      sopTriggerHandler({ uuid: this.job.uuid })
    } finally {
      this.context.loading = false
    }
  }
  async updateForm() {
    const newDoc = await SeaCargoDoc.getSeaCargoDoc(this.form.uuid)
    if (newDoc) {
      Object.assign(this.form, newDoc)
      this.form.isDirty = false
    }
  }
  async loadCargoDoc2Handler(cargoDocList) {
    this.form = null
    this._hblCargoDoc = null
    const cargoDocs = []
    if (cargoDocList && cargoDocList.length > 0) {
      cargoDocList = sortByMultiFieldAndOrder(cargoDocList, { hblNbr2: 'asc' })
      for (const hCargoDoc of cargoDocList) {
        if (hCargoDoc.chargePrint) hCargoDoc.chargePrint = false
        if (hCargoDoc.docType === CargoDocConsts.HBL) {
          this._hblCargoDoc = hCargoDoc
        } else if (hCargoDoc.docType === CargoDocConsts.HBL2) {
          cargoDocs.push(hCargoDoc)
        }
      }
    }
    if (cargoDocs.length > 0) {
      this.form = cargoDocs[0]
    } else { // 不存在拆并单的时候，新创建一个空的对象
      this.form = new SeaCargoDoc().fillDefaultValue().getData()
      this.form.releaseType = 1
    }
    if (this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code) { // 拆单
      this.view.splitOrder.rowData = cargoDocs || []
    } else { // 并单
      if (this.view.isEdit && !this.form.uuid) { // 新增并单的时候
        await this.onAddCargoDoc2()
        this.job.seaCargoDoc.push(this.form)
      }
    }
    if (this.view.isEdit && this.form.uuid && !this.form.paymentTerm) {
      const paymentTerm = this.paymentTermList.find(p => p.code === this.job.paymentTermHBL)
      this.form.paymentTerm = paymentTerm ? paymentTerm.name : ''
    }
    this.view.chkConsolidationClosed = false
    if (this.form.uuid) {
      // 不管是编辑还是新增，如果ediContainer的length为空对象，则置空，让其能够重新查询，解决不能显示数据库的问题【这里暂时】
      // if (!this.form.ediContainer || this.form.ediContainer.length <= 0) {
      //   this.form.ediContainer = ''
      // }
      await new SeaCargoDoc(this.form).loadCargoDocRelated(true, true, true)
      this.loadAfrAddressHandler(this.form.afrAddress[0])
    } else {
      this.form.afrAddress = this.form.afrAddress || []
      this.form.ediContainer = this.form.ediContainer || []
      this.form.freightCharges = this.form.freightCharges || []
    }
    this.loadFreightChargesHandler(this.form.freightCharges)
    this.editingChanged()
    this.loadSplitMBLs()
    await new SeaCargoDoc(this.form).getEdiContainer().then(data => {
      this.view.container.rowData = data
    })
    this.showScac()
    this.showDocState()
  }
  loadJointSlaves2Handler(jointSlavesHBL) {
    this.view.mergeOrder.rowData = jointSlavesHBL
    this.printStateChange()
  }
  showScac() {
    const company = this.context.companyList.find(p => p.cmpIdx === this.job.carrierId)
    this.view.txtCarrierScAc = company ? company.scac : ''
    const company1 = this.context.companyList.find(p => p.cmpIdx === this.job.destinationAgent)
    this.view.txtBookingAgentScAc = company1 ? company1.scac : ''
  }
  loadAfrAddressHandler(afrAddress) {
    this.view.chkConsolidationClosed = afrAddress && afrAddress.consolidationClosed > 0
  }
  async updateGuaranteeStateInfo() {
    if (this.form.uuid) {
      const guaranteeStateInfo = await getGuaranteeStateInfo({ cargoDocUuid: this.form.uuid }).then(res => res.data)
      // 长期保函状态：0-无保函，1-生效中，2-已生效
      // 单票保函状态：0-未上传，1-已上传，2-无需上传
      if (guaranteeStateInfo) {
        this.view.longTermGuaranteeState = guaranteeStateInfo.longTermGuaranteeState
        this.view.singleTicketGuaranteeState = guaranteeStateInfo.singleTicketGuaranteeState
        this.view.guaranteeConfigEnable = guaranteeStateInfo.configEnable
      }
    }
  }
  loadFreightChargesHandler(freightCharges) {
    this.view.rowData = freightCharges
  }

  refreshQuantitySum() {
    const packing = this.packingList.find(p => p.code === this.form.packing)
    this.form.quantitySum = StrUtils.jsdx(this.form.quantity, packing ? packing.name : '')
  }
  /**
   * refresh
   */
  async refreshSeqContainer() {
    this.form.seaeq = SeaExportUtils.getJoinSeaDocSeaEQDesc(this.form, this.job, this.form.printParam1, 'Part of')
    this.form.container = await SeaExportUtils.getContainerQWCDesc(this.form, this.form.printParam3)
  }
  /**
   * refresh
   */
  async changeContainer() {
    this.form.container = await SeaExportUtils.getContainerQWCDesc(this.form, this.form.printParam3)
  }
  printStateChange() {
    this.view.btnPrintDisabled = true
    if (this.view.isEdit) {
      return
    }
    // 是否异地放单 ,如果是TRUE，正本打印、电放按钮无法打印
    if (this.form.oversea && this.form.releaseType === 1) {
      return
    }
    if (this.form.releaseType === 1) {
      if (this.view.$checkPermission(['button_printDoc']) || this.user.admin) {
        if (this.form.state === 1) {
          this.view.btnPrintDisabled = false
        }
      }
    } else if (this.form.releaseType === BillReleaseType.SURRENDERED.code) {
      // 有权限才行
      if (this.view.$checkPermission(['button_HBL_surrender']) || this.user.admin) {
        this.view.btnPrintDisabled = false
      }
    } else {
      this.view.btnPrintDisabled = false
    }
    if (this.job.shutOut && !this.view.btnPrintDisabled) {
      this.view.btnPrintDisabled = true
    }
  }
  /**
   * 选择开航日期更新分单签单日期，订舱航期
   */
  ETD_changeCl() {
    if (this.job.etd) {
      // 分单签单日期默认更改只能前后三天内
      const etd = moment(this.job.etd)
      const nextDay = etd.add(4, 'd')
      const fourDaysAgo = etd.subtract(4, 'd')
      if (this.view.$checkPermission(['filter_SEBooking_hblSignDate'])) {
        this.dfSignDateHBLDisabledRanges = null
      } else {
        this.dfSignDateHBLDisabledRanges = [{ rangeStart: nextDay }, { rangeEnd: fourDaysAgo }]
      }
    } else {
      this.dfSignDateHBLDisabledRanges = null
    }
  }
  /**
   * 加载主单拆单信息
   */
  loadSplitMBLs() {
    if (this.job.typeHBL !== BillType.SPLIT_BILL_TYPE.code) {
      return
    }
    this.joinMBLs.splice(0, this.joinMBLs.length)
    for (const doc of this.job.seaCargoDoc) {
      if (doc.docType === CargoDocConsts.MBL2 && this.job.typeMBL === BillType.SPLIT_BILL_TYPE.code && !doc.deleted) {
        if (!this.joinMBLs.includes(doc)) {
          this.joinMBLs.push(doc)
        }
      }
    }
    this.joinMBLs = sortByMultiFieldAndOrder(this.joinMBLs, { mblNbr2: 'asc' })
  }
  changeAfrAddress() {
    let afrAddress = null
    if (!this.form.afrAddress && this.view.chkConsolidationClosed) {
      afrAddress = new AfrAddress()
      afrAddress.state = 0
      afrAddress.docType = CargoDocConsts.AFR
      afrAddress.cargoDocUuid = this.form.uuid
      this.form.afrAddress.push(afrAddress)
    } else {
      afrAddress = this.form.afrAddress[0]
    }
    if (afrAddress) {
      afrAddress.consolidationClosed = this.view.chkConsolidationClosed ? 1 : 0
    }
  }
  /**
   * 编辑船名航次模式
   */
  editInputVesselModel() {
    switch (this.editVesselVoyageMode) {
      case 1:
        this._allowEditingVessel = true
        break
      case 2:
        if (this.job.bookingTerm !== BookingTerm.OS_BOOKING_TYPE.code) {
          this._allowEditingVessel = true
        }
        break
      case 3:
        this._allowEditingVessel = false
        break
      default:
        break
    }
  }
  /**
   * 拼箱小票，不允许编辑：目的港代理、船名、航次、订舱单位、船公司、主单运费条款、卸货港
   */
  lclslaveEnabledCl() {
    this._lclslaveEnabled = this.view.isEdit && !this.job.lclMasterUuid
  }
  editingChanged() {
    this.printStateChange()
    this.lclslaveEnabledCl()
  }
  /**
   * clear input
   */
  onClear(type) {
    switch (type) {
      case 1:
        this.form.shipperCode = ''
        this.form.shipperLine1 = ''
        this.form.shipperLine2 = ''
        this.form.shipperLine3 = ''
        this.form.shipperLine4 = ''
        this.form.shipperLine5 = ''
        this.form.shipperLine6 = ''
        this.form.shipperLine7 = ''
        break
      case 2:
        this.form.consigneeCode = ''
        this.form.consigneeLine1 = ''
        this.form.consigneeLine2 = ''
        this.form.consigneeLine3 = ''
        this.form.consigneeLine4 = ''
        this.form.consigneeLine5 = ''
        this.form.consigneeLine6 = ''
        this.form.consigneeLine7 = ''
        break
      case 3:
        this.form.notifyCode = ''
        this.form.notifyLine1 = ''
        this.form.notifyLine2 = ''
        this.form.notifyLine3 = ''
        this.form.notifyLine4 = ''
        this.form.notifyLine5 = ''
        this.form.notifyLine6 = ''
        this.form.notifyLine7 = ''
        break
      case 4:
        this.form.agentPartyLine1 = ''
        this.form.agentPartyLine2 = ''
        this.form.agentPartyLine3 = ''
        this.form.agentPartyLine4 = ''
        this.form.agentPartyLine5 = ''
        this.form.agentPartyLine6 = ''
        this.form.agentPartyLine7 = ''
        break
      default:
        break
    }
  }
  // 添加装箱信息
  addUsageForGrid(usages) {
    if (usages && usages.length > 0) {
      // 若待添加装箱信息中存在已移除的装箱信息，则将其删除状态置为false, 并且将其在usages移除掉
      const usageList = this.view.container.rowData
      for (let i = usages.length - 1; i >= 0; i--) {
        const item = usages[i]
        for (const row of usageList) {
          if (item.container.eqSize === row.eqSize && item.container.eqType === row.eqType &&
              item.container.containerNo === row.containerNo && item.container.sealNo === row.sealNo && row.deleted) {
            row.quantity = NumberUtils.ToFixed2(item.quantity, 3)
            row.weight = NumberUtils.ToFixed2(item.weight, 3)
            row.cubage = NumberUtils.ToFixed2(item.cubage, 3)
            row.deleted = false
            row.used = true // 记录已经被使用了
            usages.splice(i, 1) // 重新添加以后，移除掉，避免下面又重新条件了一次
          }
        }
      }
      if (usages.length > 0) {
        for (const item of usages) {
          if (!this.existContainerUsage(item, usageList)) {
            const ec = new EDIContainer().fillDefaultValue().getData()
            ec.deleted = false
            ec.used = true // 记录已经被使用了
            ec.containerNo = item.container.containerNo
            ec.sealNo = item.container.sealNo
            ec.eqType = item.container.eqType
            ec.eqSize = item.container.eqSize
            ec.quantity = NumberUtils.ToFixed2(item.quantity, 3)
            ec.weight = NumberUtils.ToFixed2(item.weight, 3)
            ec.cubage = NumberUtils.ToFixed2(item.cubage, 3)
            ec.cargoDocUuid = this.form.uuid
            ec.containerUsageUuid = item.uuid
            usageList.push(ec)
          }
        }
      }
      this.view.container.rowData = usageList
    }
  }
  // 验证是否已存在
  existContainerUsage(u, rowData = []) {
    if (rowData && rowData.length > 0) {
      const finalRowData = rowData.filter(p => !p.deleted)
      for (const item of finalRowData) {
        if (u.container.eqSize === item.eqSize && u.container.eqType === item.eqType &&
            u.container.containerNo === item.containerNo && u.container.sealNo === item.sealNo) {
          return true
        }
      }
    }
    return false
  }
  // 添加装箱信息（通过uuid匹配）
  addUsageForGridByUuid(usages) {
    if (usages && usages.length > 0) {
      const rowData = this.view.container.rowData
      const newRows = []
      for (const usage of usages) {
        let isExist = false
        for (const row of rowData) {
          if (row.containerUsageUuid === usage.uuid) {
            row.containerNo = usage.container.containerNo
            row.sealNo = usage.container.sealNo
            row.eqType = usage.container.eqType
            row.eqSize = usage.container.eqSize
            if (row.deleted) {
              row.quantity = NumberUtils.ToFixed2(usage.quantity, 3)
              row.weight = NumberUtils.ToFixed2(usage.weight, 3)
              row.cubage = NumberUtils.ToFixed2(usage.cubage, 3)
              row.deleted = false
              row.used = true // 记录已经被使用了
            } else {
              row.quantity = NumberUtils.ToFixed2((Number(row.quantity) || 0) + usage.quantity, 3)
              row.weight = NumberUtils.ToFixed2((Number(row.weight) || 0) + usage.weight, 3)
              row.cubage = NumberUtils.ToFixed2((Number(row.cubage) || 0) + usage.cubage, 3)
              row.deleted = false
              row.used = true // 记录已经被使用了
            }
            isExist = true
            break
          }
        }
        if (!isExist) {
          const ec = new EDIContainer().fillDefaultValue().getData()
          ec.deleted = false
          ec.used = true // 记录已经被使用了
          ec.containerNo = usage.container.containerNo
          ec.sealNo = usage.container.sealNo
          ec.eqType = usage.container.eqType
          ec.eqSize = usage.container.eqSize
          ec.quantity = NumberUtils.ToFixed2(usage.quantity, 3)
          ec.weight = NumberUtils.ToFixed2(usage.weight, 3)
          ec.cubage = NumberUtils.ToFixed2(usage.cubage, 3)
          ec.cargoDocUuid = this.form.uuid
          ec.containerUsageUuid = usage.uuid
          newRows.push(ec)
        }
      }
      rowData.push(...newRows)
    }
  }
  /**
   * 刷新费用大写和总计
   */
  refershFreightChargeTotal() {
    let totalAmount = 0
    for (const charge of this.view.finalRowData) {
      if (charge.currency === 'USD') { // USD
        totalAmount += charge.amount
      }
    }
    this.form.freightChargeTotal = totalAmount
    this.form.freightChargeEnUpper = StrUtils.jsdx2(totalAmount)
  }
  /**
   * 发货人选择
   */
  async shipperAutoCompleteChange(data) {
    this.form.shipperId = data.value || 0
    if (data.value) {
      const company = new Company(data)
      await company.getMainfestAddress()
      this.applyShipperManifestAddress(data)
    } else {
      this.onClear(1)
    }
    await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, this.view.synchronousShipperCodeAndConsigneeCodeAndNotifyCode, 'shipper', 1)
  }
  applyShipperManifestAddress(company) {
    const manifestaddress = company.manifestAddress
    if (manifestaddress) {
      this.form.shipperCode = company.englishName
      this.form.shipperLine1 = manifestaddress.addressLine1
      this.form.shipperLine2 = manifestaddress.addressLine2
      this.form.shipperLine3 = manifestaddress.addressLine3
      this.form.shipperLine4 = manifestaddress.addressLine4
      this.form.shipperLine5 = manifestaddress.addressLine5
      this.form.shipperLine6 = manifestaddress.addressLine6
      this.form.shipperLine7 = manifestaddress.addressLine7
    } else {
      this.form.shipperCode = ''
      this.form.shipperLine1 = ''
      this.form.shipperLine2 = ''
      this.form.shipperLine3 = ''
      this.form.shipperLine4 = ''
      this.form.shipperLine5 = ''
      this.form.shipperLine6 = ''
      this.form.shipperLine7 = ''
    }
  }
  /**
   * 收货人选择
   */
  async consigneeAutoCompleteChange(data) {
    this.form.consigneeId = data.value || 0
    if (data.value) {
      const company = new Company(data)
      await company.getMainfestAddress()
      this.applyConsigneeManifestAddress(data)
    } else {
      this.onClear(2)
    }
    await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, this.view.synchronousShipperCodeAndConsigneeCodeAndNotifyCode, 'consignee', 1)
  }
  applyConsigneeManifestAddress(company) {
    const manifestaddress = company.manifestAddress
    if (manifestaddress) {
      this.form.consigneeCode = company.englishName
      this.form.consigneeLine1 = manifestaddress.addressLine1
      this.form.consigneeLine2 = manifestaddress.addressLine2
      this.form.consigneeLine3 = manifestaddress.addressLine3
      this.form.consigneeLine4 = manifestaddress.addressLine4
      this.form.consigneeLine5 = manifestaddress.addressLine5
      this.form.consigneeLine6 = manifestaddress.addressLine6
      this.form.consigneeLine7 = manifestaddress.addressLine7
    } else {
      this.form.consigneeCode = ''
      this.form.consigneeLine1 = ''
      this.form.consigneeLine2 = ''
      this.form.consigneeLine3 = ''
      this.form.consigneeLine4 = ''
      this.form.consigneeLine5 = ''
      this.form.consigneeLine6 = ''
      this.form.consigneeLine7 = ''
    }
  }
  /**
   * 通知人选择
   */
  async notifyAutoCompleteChange(data) {
    this.form.notifyId = data.value || 0
    if (data.value) {
      const company = new Company(data)
      await company.getMainfestAddress()
      this.applyNotifyManifestAddress(data)
    } else {
      this.onClear(3)
    }
    await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, this.view.synchronousShipperCodeAndConsigneeCodeAndNotifyCode, 'notify', 1)
  }
  applyNotifyManifestAddress(company) {
    const manifestaddress = company.manifestAddress
    if (manifestaddress) {
      this.form.notifyCode = company.englishName
      this.form.notifyLine1 = manifestaddress.addressLine1
      this.form.notifyLine2 = manifestaddress.addressLine2
      this.form.notifyLine3 = manifestaddress.addressLine3
      this.form.notifyLine4 = manifestaddress.addressLine4
      this.form.notifyLine5 = manifestaddress.addressLine5
      this.form.notifyLine6 = manifestaddress.addressLine6
      this.form.notifyLine7 = manifestaddress.addressLine7
    } else {
      this.form.notifyCode = ''
      this.form.notifyLine1 = ''
      this.form.notifyLine2 = ''
      this.form.notifyLine3 = ''
      this.form.notifyLine4 = ''
      this.form.notifyLine5 = ''
      this.form.notifyLine6 = ''
      this.form.notifyLine7 = ''
    }
  }
  setSelectNode(index) {
    const selectedNode = this.view.splitOrder.gridApi.getModel().rowsToDisplay[index]
    selectedNode.setSelected(true)
  }
  // 获取当前Job的并单数据的英文名品
  async getCargoEnglishNameFromMergeJob() {
    const job = new SeaExportJob(this.job)
    const jointSlavesMBL = await job.getJointSlavesHBL()
    if (jointSlavesMBL) {
      let text = this.form.cargoEnglishName
      for (const mergeJob of jointSlavesMBL) {
        const cargoDoc = await new SeaExportJob(mergeJob).getMainHbl()
        if (cargoDoc) {
          if (cargoDoc.cargoEnglishName) {
            if (text) {
              text = text + '\n' + cargoDoc.cargoEnglishName
            } else {
              text = cargoDoc.cargoEnglishName
            }
          }
        }
      }
      this.form.cargoEnglishName = text
    }
  }
  // 获取当前Job的并单数据的唛头
  async getMarkFromMergeJob() {
    const job = new SeaExportJob(this.job)
    const jointSlavesMBL = await job.getJointSlavesHBL()
    if (jointSlavesMBL) {
      let text = this.form.mark
      for (const mergeJob of jointSlavesMBL) {
        const cargoDoc = await new SeaExportJob(mergeJob).getMainHbl()
        if (cargoDoc) {
          if (cargoDoc.mark) {
            if (text) {
              text = text + '\n' + cargoDoc.mark
            } else {
              text = cargoDoc.mark
            }
          }
        }
      }
      this.form.mark = text
    }
  }
  /**
   * 获取最近修改的对单记录
   */
  async loadCheckDocs() {
    const checkDocHistories = await CheckCargoDocHistory.queryDocHistoryByTime(this.form.uuid)
    this.queryTopCheckDocHistoriesHandler(checkDocHistories)
  }
  queryTopCheckDocHistoriesHandler(checkDocHistories) {
    this.comparedCargoDocIsModified(checkDocHistories)
  }
  /**
   * 对单后把有修改的内容显示红色
   */
  comparedCargoDocIsModified(checkDocHistories) {
    if (checkDocHistories && checkDocHistories.length > 0) {
      const variableCss = this.view.variableCss
      // 获取对单记录的第一条记录，根据是否有标识字段判断是否对单时修改了字段,有字段修改的情况去改变字段颜色
      const firstCheckDaoHistory = checkDocHistories[0]
      if (firstCheckDaoHistory.fieldName !== 'noChange') {
        for (const checkDocHistory of checkDocHistories) {
          const fieldName = checkDocHistory.fieldName
          if (variableCss.hasOwnProperty(fieldName)) {
            if (fieldName === 'cargoEnglishName' && this.form.cargoEnglishName.length >= 45) {
              continue
            } else if (fieldName === 'mark' && this.form.mark.length >= 22) {
              continue
            }
            this.checkHistoryTextMapChanged(checkDocHistory, checkDocHistories)
          }
        }
      }
    }
  }
  /**
   * 对单内容
   */
  checkHistoryTextMapChanged(checkDocHistory, checkDocHistories) {
    switch (checkDocHistory.fieldName) {
      case 'shipperLine':
        this.checkHistoryByShipperConsigneeNotifyLine('shipperLineOld', 'shipperLine', checkDocHistory, checkDocHistories)
        break
      case 'consigneeLine':
        this.checkHistoryByShipperConsigneeNotifyLine('consigneeLineOld', 'consigneeLine', checkDocHistory, checkDocHistories)
        break
      case 'notifyLine':
        this.checkHistoryByShipperConsigneeNotifyLine('notifyLineOld', 'notifyLine', checkDocHistory, checkDocHistories)
        break
      case 'agentPartyLine':
        this.checkHistoryByShipperConsigneeNotifyLine('agentPartyLineOld', 'agentPartyLine', checkDocHistory, checkDocHistories)
        break
      default:
        this.view.variableCss[checkDocHistory.fieldName] = 'red'
        break
    }
  }
  /**
   * 检查收发通知人是否发生变化
   */
  checkHistoryByShipperConsigneeNotifyLine(oldField, textField, checkDocHistory, checkDocHistories) {
    const line = checkDocHistory.fieldValue
    const oldLine = this.getDocHistoryShipperConsigneeNotify(oldField, checkDocHistories)
    const lines = line.split('|')
    const oldLines = oldLine.split('|')
    for (let i = 0; i < lines.length; ++i) {
      const index = i + 1
      const line2 = lines[i].replace('\r\n', '')
      const lineOld2 = oldLines[i].replace('\r\n', '')
      if (line2 !== lineOld2) {
        this.view.variableCss[textField] = 'red'
        this.view.variableCss[textField + index] = 'red'
      }
    }
  }
  /**
   * 获取上一个版本收发通历史的数据
   */
  getDocHistoryShipperConsigneeNotify(fieldName, checkDocHistories) {
    for (let i = 0; i < checkDocHistories.length; i++) {
      if (checkDocHistories[i].fieldName === fieldName) {
        return checkDocHistories[i].fieldValue
      }
    }
    return ''
  }
  /**
   * 重置对单颜色
   */
  resetColor() {
    for (const key in this.view.variableCss) {
      if (key === 'cargoEnglishName' && this.form.cargoEnglishName.length >= 45) {
        continue
      } else if (key === 'mark' && this.form.mark.length >= 22) {
        continue
      }
      this.view.variableCss[key] = ''
    }
  }
  portChange(p, field) {
    const form = this.form
    form[field + 'Code'] = p.value
    form[field] = p.englishName
  }
  /**
   * 提单数据更新
   */
  updateBillInfo(release = false, ifSystemSend = false) {
    if (this.form.docType !== CargoDocConsts.HBL2) {
      this.$message.warning(this.view.$t('CargoMsg.PleaseCreateSplitBillFirst'))
      return
    }
    const phone = this.view.getContactPhone()
    if (!phone) {
      return
    }
    this.loading = getLoading()
    const params = {
      jobUuid: this.job.uuid,
      docUuid: this.view.form.uuid,
      release: release,
      ifSystemSend: ifSystemSend
    }
    xhqUpdateBillInfo(params).then(res => {
      if (res.data) {
        this.$message.warning(res.data)
      } else {
        this.$message.success(this.view.$t('CargoMsg.Cargo_SendSuccess'))
        if (release) {
          this.view.form.confirmationBillState = CFM_BILL_STATE_UPDATE.code
        } else {
          this.view.form.confirmationBillState = CFM_BILL_STATE_RELEASE.code
        }
      }
    }).finally(() => {
      this.loading.close()
    })
  }
  /**
   * 上传文件
   */
  async toUploadFile(fileCategory, fileCategoryLabel, xhqSendType) {
    if ((fileCategory !== 'SHIPPING_ORDER' && this.view.form.confirmationBillState === CFM_BILL_STATE_NEW.code)) {
      this.$message.warning(this.view.$t('SeaExport.CfmBillFirst'))
      return
    }
    if (fileCategory !== 'SHIPPING_ORDER' && this.view.form.releaseState === ReleaseState.ONSINGLERELEASE.code) {
      this.$message.warning(this.view.$t('SeaExport.IsReleased'))
      return
    }
    if (fileCategory === 'SHIPPING_ORDER' && !(this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_WKS.code || this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_ZDD.code)) {
      this.$message.warning(this.view.$t('SeaExport.UnStartOrUnConfirmCanUpload'))
      return
    }
    const phone = this.view.getContactPhone()
    if (!phone) {
      return
    }
    // 将信号旗的文件类型转换为CARGO的文件类型
    const documentType = await getDocumentTypeByExt({ externalFileType: fileCategory }).then(res => {
      return res.data
    })
    this.view.cloudFile.job.jobNo = this.job.jobNo
    this.view.cloudFile.job.lob = this.job.lob
    this.view.cloudFile.job.mbl = this.job.mbl
    this.view.cloudFile.job.uuid = encodeURIComponent(this.form.uuid)
    this.view.cloudFile.visible = true
    this.view.cloudFile.fileCategory = documentType
    this.view.cloudFile.fileCategoryLabel = fileCategoryLabel
    this.view.cloudFile.uploadSource = 'tblHBL2'
    this.view.cloudFile.otherParam.hblNo = this.view.form.hblNbr2
    this.view.cloudFile.otherParam.hblRefNo = this.view.form.hblRefNo
    this.view.cloudFile.otherParam.xhqSendType = xhqSendType // 发送信号旗传的[type]参数，BILL表示提单确认件，OWN_BILL表示客户自出单, SHIPPING_ORDER表示托书文件
  }
  /**
   * 上传文件（通用）
   */
  async toUploadCommonFile(fileCategory, fileCategoryLabel) {
    this.view.cloudFile.job.jobNo = this.job.jobNo
    this.view.cloudFile.job.lob = this.job.lob
    this.view.cloudFile.job.mbl = this.job.mbl
    this.view.cloudFile.job.uuid = encodeURIComponent(this.form.uuid)
    this.view.cloudFile.visible = true
    this.view.cloudFile.fileCategory = fileCategory
    this.view.cloudFile.fileCategoryLabel = fileCategoryLabel
    this.view.cloudFile.uploadSource = 'tblHBL2'
    this.view.cloudFile.otherParam.hblNo = this.view.form.hblNbr2
    this.view.cloudFile.otherParam.hblRefNo = this.view.form.hblRefNo
    this.view.cloudFile.otherParam.xhqSendType = ''
  }
  /**
   * 对单中心日志
   */
  async toCheckTheBLLog() {
    this.view.checkTheBLLog.jobUuid = this.form.uuid
    this.view.checkTheBLLog.visible = true
    const logSource = []
    for (const item of SystemConstants.XHQ_INTERFACE) {
      logSource.push(item.code)
    }
    const logSourceStr = logSource.join(',')
    const params = {
      jobUuid: this.job.uuid,
      logSource: logSourceStr
    }
    await xhqQueryCheckTheBLLog(params).then(res => {
      this.view.checkTheBLLog.rowData = res.data
    })
  }

  async toGetXHQCfmAddress(cargoDocUuid) {
    return await xhqGetCfmAddress({ cargoDocUuid }).then(res => res.data)
  }

  toSurrendered() {
    if (this.view.form.releaseState === ReleaseState.ONSINGLERELEASE.code) {
      this.$message.warning(this.view.$t('SeaExport.IsReleased2'))
      return
    }
    if (this.view.form.cfmState !== CargoDocCfmState.CARGODOC_CFM_STATE_YQR.code) {
      this.$message.warning(this.view.$t('SeaExport.BillNotCfm'))
      return
    }
    if (this.view.form.releaseState !== ReleaseState.SINGLERELEASE.code && this.view.IfXHQReleaseRequireHBLReleaseReview === 1) {
      this.$message.warning(this.view.$t('SeaExport.BillNotRelease'))
      return
    }
    if (!this.view.job.atd) {
      this.$message.warning(this.view.$t('SeaExport.ATDIsNull'))
      return
    }
    if (!(this.view.form.releaseType === BillReleaseType.SURRENDERED.code)) {
      this.$message.warning(this.view.$t('SeaExport.OnlySurrenderedSupport'))
      return
    }
    this.updateBillInfo(true)
  }
  docCfmStateChanged() {
    const isZh = this.$i18n.locale === 'zh'
    const cfmState = CargoDocCfmState.getCargoDocCfmStateByCode(this.form.cfmState)
    if (cfmState) {
      this.view.lblCfrState = isZh ? cfmState.chineseName : cfmState.englishName
    }
    const releaseState = ReleaseState.getReleaseStateByCode(this.form.releaseState)
    if (releaseState) {
      this.view.lblReleaseState = isZh ? releaseState.chineseName : releaseState.englishName
    }
  }

  /**
   * 客户自出单
   */
  isCustomerSelfRelease(value) {
    if (value) {
      this.form.customerSelfRelease = 1
    } else if (this.form.customerSelfRelease === 1) {
      this.form.customerSelfRelease = 0
    }
  }
  /**
   * 公司自出单
   */
  isCompanySelfRelease(value) {
    if (value) {
      this.form.customerSelfRelease = 2
    } else if (this.form.customerSelfRelease === 2) {
      this.form.customerSelfRelease = 0
    }
  }

  btnRequestReleasingClickHandler() {
    const { requestReleaseState, uuid } = this.view.form
    const uuids = [uuid]
    if (requestReleaseState === 0) {
      this.loading = getLoading()
      requestRelease(uuids).then(async res => {
        this.loading.close()
        this.view.form.requestReleaseState = 1
        await SeaCargoDoc.handlerCargoDocForRequestRelease(this.view.form)
        this.view.lblReleaseState = ColumnUtils.releaseStateLabelFunc(Number(res.data[uuid].releaseState))
        this.view.$message.success(this.view.$t('SeaExport.StatusModefySuccessfully'))
      }).catch(() => {
        this.loading.close()
      })
      return
    }
    this.loading = getLoading()
    cancelRequestRelease(uuids).then(async res => {
      this.loading.close()
      this.view.form.requestReleaseState = 0
      await SeaCargoDoc.handlerCargoDocForRequestRelease(this.view.form)
      this.view.$message.success(this.view.$t('SeaExport.StatusModefySuccessfully'))
    }).catch(() => {
      this.loading.close()
    })
  }

  /**
   * 并单添加装箱信息
   * @param usages
   */
  addUsageForMerge(usages) {
    if (usages && usages.length > 0) {
      const rowData = this.view.container.rowData
      const newRows = []
      // 是否并单，并单的情况下一个箱子只能加入一次，不能反复加入
      for (const usage of usages) {
        let isExist = false
        for (const row of rowData) {
          if (row.containerUsageUuid === usage.uuid) {
            isExist = true
            break
          }
        }
        if (isExist) {
          continue
        }
        const ec = new EDIContainer().fillDefaultValue().getData()
        ec.deleted = false
        ec.used = true // 记录已经被使用了
        ec.containerNo = usage.container.containerNo
        ec.sealNo = usage.container.sealNo
        ec.eqType = usage.container.eqType
        ec.eqSize = usage.container.eqSize
        ec.quantity = NumberUtils.ToFixed2(usage.quantity, 3)
        ec.weight = NumberUtils.ToFixed2(usage.weight, 3)
        ec.cubage = NumberUtils.ToFixed2(usage.cubage, 3)
        ec.cargoDocUuid = this.form.uuid
        ec.containerUsageUuid = usage.uuid
        newRows.push(ec)
      }
      rowData.push(...newRows)
    }
  }
}
